import ContentfulHyperlink from './ContentfulHyperlink'

export default ContentfulHyperlink
